import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import helperNumbers from "../../../helpers/numbers";
import NotificationBell from "./NotificationBell";

function User({ firstNameUser, lastNameUser, email, mobile, userID, role }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const body = document.querySelector("body");
    const except = document.querySelector("#popover-user-icon-nav");
    body.addEventListener(
      "click",
      function () {
        setShow(false);
      },
      false
    );
    except.addEventListener(
      "click",
      function (ev) {
        ev.stopPropagation();
      },
      false
    );
  }, []);

  return (
    <div className="d-flex">
      <div className="nav-item d-sm-inline-block">
        <span
          // className="nav-link p-0 mr-2 btn btn-power-off position-relative"
          className={`nav-link p-0 mr-2  position-relative btn btn-power-off ${
            show && "btn-power-off-hover"
          }`}
          onClick={(e) => {
            setShow((prevState) => {
              return !prevState;
            });
          }}
        >
          <i className="fa fa-user"></i>
        </span>
        <div
          className={`${show ? "" : "d-none"}   position-absolute`}
          id="popover-user-icon-nav"
        >
          <div className="d-flex justify-content-end  position-relative">
            <div className="icon-triangle "></div>
          </div>
          <div className="popover-body p-3 ">
            <div className="py-2">
              <span>نام کاربری</span>
              <span className="px-2">:</span>
              <span className="d-inline-flex">
                <p className="pl-1 m-0">{firstNameUser}</p>
                <p className="m-0">{lastNameUser}</p>
              </span>
            </div>
            <div className="py-2">
              <span>شماره کاربری</span>
              <span className="px-2">:</span>
              <span>{helperNumbers.toPersianNum(userID)}</span>
            </div>
            <div className="py-2">
              <span>نقش</span>
              <span className="px-2">:</span>
              <span>{role}</span>
            </div>
            <div className="py-2">
              <span>اطلاعات ضروری</span>
            </div>
            <div className="py-2">
              <span>شماره موبایل</span>
              <span className="px-2">:</span>
              <span dir="ltr">
                {mobile != undefined
                  ? helperNumbers.toPersianNum(
                      helperNumbers.presentMobileNumber(mobile)
                    )
                  : ""}
              </span>
            </div>
            <div className="py-2">
              <span>ایمیل</span>
              <span className="px-2">:</span>
              <span> {email}</span>
            </div>

            <div className="d-lg-none py-2">
              <NotificationBell />
            </div>

            <div className="py-2">
              <div className="border border-1 border-success"></div>
            </div>
            <div className="py-2 d-flex justify-content-between">
              <Link
                to={`${
                  role == "بازاریاب" ? "/user/marketer/info" : "/user/info"
                }`}
                className="btn btn-info"
              >
                <i className="hl-user pl-2 align-middle"></i>
                اطلاعات کاربری
              </Link>
              <Link to="/logout" className="btn btn-danger">
                <i className="hl-logout-a pl-2 align-middle"></i>
                خروج از پنل
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    userID: state.main.userID,
    firstNameUser: state.main.firstNameUser,
    lastNameUser: state.main.lastNameUser,
    email: state.main.email,
    mobile: state.main.mobile,
    role: state.main.role,
  };
};

const mapDispatchToProps = () => {
  return {};
};
export default connect(mapStateToProps, null)(User);
